import { useQuery } from '@tanstack/react-query';
import { http } from 'services/http';
import { TRIPS_LOAD_STATISTICS_GET } from 'api/query-keys';
import type { TGetTripsLoadStatisticsRes } from 'api/swagger';
import type { ITransportLoadFilter } from 'shared/stores/use-transport-load-filters';
import { setFiltersToQs } from 'shared/utils/filters/set-filters-to-qs';

interface IParams {
  filters: ITransportLoadFilter;
}

export const useGetTripsLoadStatistics = ({ filters }: IParams) => {
  const qs = new URLSearchParams();
  setFiltersToQs<ITransportLoadFilter>(qs, filters);

  return useQuery({
    queryKey: [TRIPS_LOAD_STATISTICS_GET, { filters }],
    queryFn: async () => {
      const { data } = await http.get<TGetTripsLoadStatisticsRes>(
        `/v1/statistics/trips-load-by-manager?${qs.toString()}`,
      );
      return data;
    },
    retry: false,
    refetchOnWindowFocus: false,
    enabled: !!filters.date && !!filters.userId,
  });
};
